<template>
  <div>
    <div class="d-flex aec-logo">
      <v-hover
        v-slot:default="{ hover }"
        v-for="(item, index) in items"
        :key="index"
      >
        <!-- logo img -->
        <div :style="item.style" class="transition-ease-in-out">
          <div
            style="border-radius: 34px"
            :style="{
                width: (hover ? (wrapWidth <= 1536 ? 84 : 115) : (wrapWidth <= 1536 ? 72 : 100)) + 'px',
                height: (hover ? (wrapWidth <= 1536 ? 84 : 115) : (wrapWidth <= 1536 ? 72 : 100)) + 'px',
                'box-shadow': hover ? '0 0 56px rgba(0,0,0,0.1)' : '0 0 56px rgba(0,0,0,0)'
                }"
            class="transition-ease-in-out"
          >
            <v-img
              :src="require(`../../../assets/pc/cooperation/outer/${item.img}`)"
              :lazy-src="require(`../../../assets/pc/cooperation/outer/${item.img}`)"
            ></v-img>
          </div>
          <!-- logo name -->
          <div
            class="pt-3 text-center"
            style="font-size: 0.625rem;"
            :style="{
                 color: hover ? '#134D91' : '#333'
              }"
          >{{ item.name }}
          </div>
        </div>
      </v-hover>
    </div>
    <v-img
      :src="require('../../../assets/pc/aboutMe/半个地图.png')"
      :lazy-src="require('../../../assets/pc/aboutMe/半个地图.png')"
    >
      <div class="fill-height d-flex justify-center align-start pt-13">
        <div
          class="d-flex justify-center align-center aec-more transition-ease-in-out"
          @click.stop="onclickGoToCooperation"
        >
          点击查看更多
        </div>
      </div>
    </v-img>
  </div>
</template>

<script>
export default {
  name: 'cooperation',
  props: ['cooperationItems', 'wrapWidth'],
  data: () => ({
    cooperationNum: 0,
    items: []
  }),
  methods: {
    onclickGoToCooperation () {
      this.$emit('onChange', {
        route: '/cooperation'
      })
      this.showMenu = false
    },
    // 合作机构
    setCooperationItems (bt, lt, btNum, order) {
      let cooperationItems = []
      btNum = btNum || 8
      this.cooperationItems.forEach((item, index) => {
        Object.assign(item, {
          style: `bottom: ${bt}%; left: ${lt}%`
        })

        if (order === 'init') {
          cooperationItems.push(item)
        }

        lt = lt + 7
        if (index < this.cooperationNum) {
          bt = bt + btNum - index
        } else if (index >= this.cooperationNum) {
          bt = bt - btNum
          if (index <= 9) {
            bt = bt + 5
          } else {
            bt = bt - 3
          }
        }
      })
      if (order === 'init') {
        this.items = cooperationItems
      }
    }
  },
  created () {
    // 合作机构
    this.cooperationNum = Math.floor(this.cooperationItems.length / 2)
    this.setCooperationItems(-10, 5, 12, 'init')
  }
}
</script>

<style scoped>
.aec-more {
  width: 270px;
  height: 60px;
  border-radius: 30px;
  line-height: 60px;
  text-align: center;
  margin-top: 43px;
  cursor: pointer;
  border: 1px solid #999999;
}

.aec-more:hover {
  box-shadow: rgb(105 121 255) 1px 5px 12px;
  background-color: #6979FF;
  color: #fff;
}

.aec-more > span {
  font-size: 18px;
  font-weight: 400;
  padding: 12px 0 12px 0;
  color: white;
}

.aec-logo {
  height: 250px;
  position: relative;
}

.aec-logo > div {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/aboutMe/cooperation.vue